import(/* webpackMode: "eager", webpackExports: ["InboxClient"] */ "/app/components/admin/inbox/inbox-client.tsx");
